// extracted by mini-css-extract-plugin
export default {"th":"TableSort_th__lO6p+","control":"TableSort_control__1j0Cg","icon":"TableSort_icon__IeMiv"};